import script from "./DiagramImageComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiagramImageComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__